var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAudio = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 64 64",
    height: "64px",
    viewBox: "0 0 64 64",
    width: "64px",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    fill: "#76C2AF",
    r: 32
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.851,49.42c1.596,2.071,4.892,2.206,7.362,0.303C22.218,48.948,24,46.844,24,42.531V29.194l19-3.629     v8.418c0,2.97-2.405,3.652-3.21,3.804c-0.07,0.009-0.139,0.026-0.209,0.038c-0.036,0.004-0.09,0.011-0.09,0.011l0.013,0.004     c-0.951,0.173-1.909,0.572-2.769,1.233c-2.47,1.903-3.181,5.124-1.585,7.196c1.596,2.071,4.892,2.208,7.362,0.305     C43.763,45.61,45,43.75,45,40.844V18.514c0-1.178-0.956-1.843-2.133-1.483l-19.2,3.629C22.489,21.019,22,22.267,22,23.445v12.993     c0,2.974-2.745,4.351-3.547,4.5c-0.041,0.006-0.081,0.019-0.124,0.026c-0.105,0.017-0.173,0.023-0.173,0.023l0.023,0.011     c-0.943,0.177-1.892,0.572-2.743,1.227C12.966,44.127,12.258,47.348,13.851,49.42z",
    fill: "#231F20"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.851,47.42c1.596,2.071,4.892,2.206,7.362,0.303C22.218,46.948,24,44.844,24,40.531V27.194l19-3.629     v8.418c0,2.97-2.405,3.652-3.21,3.804c-0.07,0.009-0.139,0.026-0.209,0.038c-0.036,0.004-0.09,0.011-0.09,0.011l0.013,0.004     c-0.951,0.173-1.909,0.572-2.769,1.233c-2.47,1.903-3.181,5.124-1.585,7.196c1.596,2.071,4.892,2.208,7.362,0.305     C43.763,43.61,45,41.75,45,38.844V16.514c0-1.178-0.956-1.843-2.133-1.483l-19.2,3.629C22.489,19.019,22,20.267,22,21.445v12.993     c0,2.974-2.745,4.351-3.547,4.5c-0.041,0.006-0.081,0.019-0.124,0.026c-0.105,0.017-0.173,0.023-0.173,0.023l0.023,0.011     c-0.943,0.177-1.892,0.572-2.743,1.227C12.966,42.127,12.258,45.348,13.851,47.42z",
    fill: "#FFFFFF"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAudio, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/audio.2f9bf304.svg";
export { ForwardRef as ReactComponent };